import React, { useState } from 'react'

import './App.css'
import '@aws-amplify/ui-react/styles.css'
import { MyRoutes } from './MyRoutes'
import { getClientModule } from '@mytmpvpn/mytmpvpn-client'
import { MyTmpVpnClient } from '@mytmpvpn/mytmpvpn-client'
// This module is generated at build time.
// When mocking is enabled it contains a fake URL
// When mocking is not enabled it MUST contain the backend APIURL
import { MYTMPVPN_APIURL } from './appConfig'
import { Authenticator } from './amplify'

function AppContent() {
  const [client] = useState<MyTmpVpnClient>(getClientModule(MYTMPVPN_APIURL))

  return (
    <MyRoutes client={client} />
  )
}

// ThemeProvider removed: it was adding significant renderRootSync cost
// while providing no value (no custom theme was passed).
// The default Amplify design tokens are already available via the
// @aws-amplify/ui-react/styles.css import above.
function App() {
  return (
    <Authenticator.Provider>
      <AppContent />
    </Authenticator.Provider>
  )
}

export default App